<template>
  <div class="fixed inset-0 z-[10000] flex items-center justify-center bg-black/50 backdrop-blur-[4px]" @click.self="$emit('close')">
    <div class="bg-n-background rounded-2xl shadow-2xl w-full max-w-2xl max-h-[80vh] flex flex-col">
      <div class="px-6 py-5 border-b border-n-weak flex items-center justify-between">
        <h2 class="text-lg font-extrabold text-n-slate-12">Gerenciar etiquetas</h2>
        <button class="text-n-slate-9 hover:text-n-slate-11 text-xl" @click="$emit('close')">×</button>
      </div>
      <div class="px-6 py-4 space-y-4 overflow-y-auto flex-1">
        <div class="flex gap-2 items-end">
          <div class="flex-1">
            <label class="block text-xs font-medium text-n-slate-11 mb-1">Nome</label>
            <input v-model="newLabel.name" type="text" placeholder="Ex: Urgente" class="w-full px-3 py-2 rounded-xl border border-n-weak bg-n-background dark:bg-n-solid-2 text-sm text-n-slate-12" @keyup.enter="createLabel" />
          </div>
          <div>
            <label class="block text-xs font-medium text-n-slate-11 mb-1">Cor</label>
            <input v-model="newLabel.color" type="color" class="w-12 h-9 rounded cursor-pointer border border-n-strong" />
          </div>
          <button class="px-3 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-xl text-sm font-medium disabled:opacity-50" :disabled="creating || !newLabel.name.trim()" @click="createLabel">
            {{ creating ? '...' : '+ Criar' }}
          </button>
        </div>

        <div v-if="labels.length === 0" class="text-center py-8 text-sm text-n-slate-9">
          Nenhuma etiqueta criada
        </div>
        <ul v-else class="space-y-1">
          <li v-for="l in labels" :key="l.id" class="flex items-center gap-3 p-2 rounded-md hover:bg-n-alpha-1">
            <input v-model="l.name" type="text" class="flex-1 px-2 py-1 rounded border border-transparent hover:border-n-weak dark:hover:border-slate-600 focus:border-blue-500 bg-transparent text-sm text-n-slate-12" @blur="updateLabel(l)" @keyup.enter="$event.target.blur()" />
            <input v-model="l.color" type="color" class="w-8 h-8 rounded cursor-pointer border border-n-strong" @change="updateLabel(l)" />
            <span class="text-xs px-2 py-0.5 rounded" :style="{ backgroundColor: l.color + '33', color: l.color }">preview</span>
            <button class="text-n-slate-9 hover:text-red-500 px-2 text-lg" @click="removeLabel(l)" title="Remover">×</button>
          </li>
        </ul>
      </div>
      <div class="px-6 py-3 border-t border-n-weak flex justify-end">
        <button class="px-4 py-1.5 text-sm rounded-xl bg-n-alpha-2 text-n-slate-11 hover:bg-n-alpha-3" @click="$emit('close')">Fechar</button>
      </div>
    </div>
  </div>
</template>

<script>
import { useAlert } from 'dashboard/composables';
import TaskLabelsAPI from 'dashboard/api/taskLabels';

export default {
  name: 'TaskLabelsManager',
  emits: ['close', 'changed'],
  data() {
    return {
      labels: [],
      newLabel: { name: '', color: '#3b82f6' },
      creating: false,
    };
  },
  mounted() { this.loadLabels(); },
  methods: {
    async loadLabels() {
      try {
        const { data } = await TaskLabelsAPI.list();
        this.labels = Array.isArray(data) ? data : [];
      } catch (e) { useAlert('Erro ao carregar etiquetas'); }
    },
    async createLabel() {
      if (!this.newLabel.name.trim()) return;
      this.creating = true;
      try {
        const { data } = await TaskLabelsAPI.create({ name: this.newLabel.name.trim(), color: this.newLabel.color });
        this.labels.push(data);
        this.newLabel.name = '';
        this.$emit('changed');
        useAlert('Etiqueta criada');
      } catch (e) { useAlert('Erro ao criar'); }
      finally { this.creating = false; }
    },
    async updateLabel(l) {
      try {
        await TaskLabelsAPI.update(l.id, { name: l.name, color: l.color });
        this.$emit('changed');
      } catch (e) { useAlert('Erro ao atualizar'); }
    },
    async removeLabel(l) {
      if (!window.confirm(`Remover etiqueta "${l.name}"?`)) return;
      try {
        await TaskLabelsAPI.remove(l.id);
        this.labels = this.labels.filter(x => x.id !== l.id);
        this.$emit('changed');
        useAlert('Etiqueta removida');
      } catch (e) { useAlert('Erro ao remover'); }
    },
  },
};
</script>
